// extracted by mini-css-extract-plugin
export default {"container":"HistoryComponent_container__N1d7V","title":"HistoryComponent_title__af8v6"};